<!--This component is designed to show the tasks in form of a modern(card) view-->
<template>
  <v-card>
    <v-toolbar card dense>
      <v-icon>view_agenda</v-icon>&nbsp; Tasks | Card View
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="refresh()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <span>Reset</span>
      </v-tooltip>
      <v-dialog v-model="sortDialog" scrollable max-width="600px">
        <template #activator="{ on }">
          <v-btn
            v-on="on"
            icon
            flat
            :loading="taskLoader"
            :disabled="areTaskGrouped"
          >
            <v-icon>sort</v-icon>
          </v-btn>
        </template>
        <v-card class="task-card">
          <v-toolbar dense flat class="body-2 beez-bold ">
            Sort By
            <v-spacer />
            <v-btn
              flat
              icon
              @click="sortDialog = false"
              :loading="taskLoader"
              class="text-capitalize"
              style="font-size: 1.1em"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-progress-linear
            color="accent"
            indeterminate
            v-if="taskLoader || appendTaskLoader"
          ></v-progress-linear>
          <v-card-text class="px-3">
            <v-layout row wrap align-center justify-center>
              <v-flex xs12>
                <v-radio-group v-model="sortByField">
                  <v-layout wrap>
                    <v-flex
                      xs6
                      v-for="(item, i) in sortByLabels"
                      :key="i + 'sortByflex'"
                    >
                      <v-card
                        :key="i + 'sortByCard'"
                        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                        flat
                        style="border-radius: 10px"
                        class="ma-1 pa-1"
                      >
                        <v-card-text>
                          <v-layout
                            align-center
                            justify-space-around
                            row
                            fill-height
                          >
                            <v-flex xs10>
                              <v-radio
                                class="pa-3"
                                :key="'radio' + i"
                                hide-details
                                color="secondary"
                                :label="item.label"
                                :value="item.value"
                              />
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                icon
                                flat
                                @click.stop="sortReverse(item)"
                                :loading="taskLoader"
                              >
                                <v-icon
                                  >{{
                                    item.desc
                                      ? 'mdi-arrow-down-bold'
                                      : 'mdi-arrow-up-bold'
                                  }}
                                </v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-tooltip bottom v-if="areTaskGrouped">
        <v-btn
          slot="activator"
          icon
          color="secondary"
          :loading="taskGroupingLoader || taskLoader"
          @click.stop="areTaskGrouped = !areTaskGrouped"
        >
          <v-icon>mdi-ungroup</v-icon>
        </v-btn>
        <span>Un Group</span>
      </v-tooltip>
      <v-dialog v-else v-model="groupDialog" max-width="800px" scrollable>
        <template #activator="{ on }">
          <v-btn
            icon
            flat
            v-on="on"
            :loading="taskGroupingLoader || taskLoader"
          >
            <v-icon>mdi-group</v-icon>
          </v-btn>
        </template>
        <v-card class="task-card">
          <v-toolbar dense flat class="beez-bold">
            Group By
            <v-spacer />
            <v-btn
              flat
              icon
              @click="groupDialog = false"
              class="text-capitalize"
              style="font-size: 1.1em"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="px-3">
            <v-layout row wrap align-center justify-center>
              <v-flex xs12>
                <v-text-field
                  v-model="searchGroupFields"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-radio-group v-model="groupByField">
                  <v-layout wrap>
                    <v-flex
                      md6
                      xs12
                      v-for="(item, i) in groupByLabels"
                      :key="i + 'groupByflex'"
                    >
                      <v-card
                        :key="i + 'groupByCard'"
                        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                        flat
                        style="border-radius: 10px"
                        class="ma-1 pa-1"
                      >
                        <v-radio
                          class="pa-1"
                          :key="'radio' + i"
                          hide-details
                          :label="item.label"
                          :value="item.value"
                        />
                        <div class="body-2 ml-2">
                          {{
                            item.dimension
                              ? 'Applicable for ' +
                                  item.count +
                                  ' task(s) with key: ' +
                                  item.formKeyDesc || item.formKey
                              : 'Applicable for ' + item.count + ' task(s)'
                          }}
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end align-end>
              <v-btn
                :outline="$vuetify.dark"
                :class="
                  $vuetify.dark
                    ? 'secondary text-capitalize'
                    : 'primary text-capitalize'
                "
                flat
                @click="groupTask"
                style="font-size: 1.1em"
                >Apply
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>
              more_vert
            </v-icon>
          </v-btn>
        </template>
        <v-list two-line>
          <v-list-tile @click="showToolbar = !showToolbar">
            <v-list-tile-content>
              <v-list-tile-title>Show/Hide Toolbar</v-list-tile-title>
              <v-list-tile-sub-title>
                Show or Hide Task card toolbar
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div v-if="areTaskGrouped" class="pb-1">
      <v-progress-linear
        color="accent"
        indeterminate
        v-if="taskGroupingLoader"
      ></v-progress-linear>
      <template v-for="(groupItem, groupIndex) in groupByItems">
        <task-group-card
          :group-id="'group-' + groupIndex"
          :selected-group-id="selectedGroupId"
          :filter-obj="filterObj"
          :show-time="showTime"
          v-if="
            !taskGroupingLoader &&
              (!filterObj ||
                !filterObj.hideInProgressTask ||
                !groupItem.inProgress)
          "
          :group-item="groupItem"
          :task-view="taskView"
          :selected-task-id="selectedTaskId"
          :key="groupIndex + 'group-task'"
          @task-selected="setSelectedTask"
          @group-selected="setSelectedGroup"
          @task-refresh="refreshWithDelay"
        ></task-group-card>
      </template>
    </div>
    <div v-else>
      <v-progress-linear
        color="accent"
        indeterminate
        v-if="taskLoader"
      ></v-progress-linear>
      <v-card
        flat
        :class="$vuetify.dark ? 'card-dark pa-1' : 'card-light pa-1'"
        style="border-radius: 10px"
      >
        <template v-for="(task, taskIndex) in items">
          <task-card
            :show-toolbar="showToolbar"
            :show-time="showTime"
            :task-id="task.id"
            :task-view="taskView"
            :task-number="taskIndex"
            :selected-task-id="selectedTaskId"
            :key="taskIndex + 'task-card-item'"
            :task-action="false"
            @task-selected="setSelectedTask"
            @task-refresh="refreshWithDelay"
          />
        </template>
      </v-card>
      <template>
        <v-flex class="mb-4 pa-2">
          <v-progress-linear
            color="accent"
            indeterminate
            v-if="appendTaskLoader"
          ></v-progress-linear>
        </v-flex>
      </template>
      <template>
        <div :id="'scrollTrigger-' + this.taskView"></div>
      </template>
    </div>
    <v-snackbar
      v-if="!areTaskGrouped"
      class="mb-2"
      color="primary"
      style="border-radius: 20px"
      v-model="snackbar"
      bottom
      :timeout="0"
    >
      <v-progress-circular
        color="secondary"
        class="mx-4"
        :value="taskShownPercent"
      ></v-progress-circular>
      Task Shown {{ items.length }} / Total Tasks
      {{ taskView === 'claimed' ? totalAssignedTasks : totalGroupTasks }}
      <v-tooltip top>
        <v-btn slot="activator" icon flat @click="gotoTop">
          <v-icon>arrow_upward</v-icon>
        </v-btn>
        <span>Scroll to top</span>
      </v-tooltip>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
import TaskGroupCard from './TaskGroupCard'
import TaskCard from './TaskCard'
import moment from 'moment'
import debounce from 'lodash/debounce'

export default {
  name: 'TaskList',
  components: { TaskCard, TaskGroupCard },
  props: {
    taskView: {
      type: String,
      default: 'claimed'
    },
    taskId: String,
    showTime: Boolean,
    isActive: Boolean,
    filterObj: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showToolbar: true,
      snackbar: true,
      showTaskHelper: true,
      scrollTrigger: null,
      search: '',
      searchGroupFields: '',
      selectedTaskId: null,
      selectedGroupId: null,
      groupDialog: false,
      sortDialog: false,
      groupByField: null,
      sortByField: 'createdAt',
      appendTaskLoader: false,
      groupExpandId: null,
      groupByItems: [],
      sortByItems: [],
      items: [],
      inProgressTaskCount: 0,
      areTaskGrouped: false,
      taskGroupingLoader: false,
      taskLoader: false,
      getTaskInProgressFlag: true,
      displayGroupBy: false,
      userInputTask: true,
      approvalTask: true,
      groupByExpand: false,
      sortByLabels: [
        { label: 'Task Name', value: 'name', desc: true },
        { label: 'Created At', value: 'createdAt', desc: true },
        { label: 'Due At', value: 'due', desc: true }
      ]
    }
  },
  created() {
    this.refresh()
  },
  watch: {
    claimedTasks() {
      this.taskItems()
    },
    unclaimedTasks() {
      this.taskItems()
    },
    sortByField() {
      this.taskItems()
    },
    filterObj() {
      this.getInitTaskPage()
    },
    groupDialog() {
      if (this.groupDialog) this.setGroupByLabels()
    },
    isActive() {
      if (this.isActive) this.refresh()
    }
  },
  mounted() {
    this.search = this.$route.query.search
    this.getSelectedFromRoute()
    this.scrollTrigger = document.getElementById(
      'scrollTrigger-' + this.taskView
    )
    this.handleDebouncedScroll = debounce(this.handleScroll, 100)
    window.addEventListener('scroll', this.handleDebouncedScroll)
    this.getInitTaskPage()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleDebouncedScroll)
  },

  methods: {
    sortReverse(item) {
      item.desc = !item.desc
      this.taskItems()
    },
    setSelectedTask(taskId) {
      this.selectedTaskId = taskId
    },
    setSelectedGroup(groupId) {
      this.selectedGroupId = groupId
    },
    handleScroll() {
      if (
        this.isActive &&
        this.scrollTrigger &&
        this.scrollTrigger.id === 'scrollTrigger-' + this.taskView
      ) {
        this.checkForMoreTasks(this.scrollTrigger)
      }
    },
    checkForMoreTasks(elm) {
      let rect = elm.getBoundingClientRect()
      let func = debounce(async () => {
        await this.appendTasks()
      }, 100)
      let viewHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight
      )
      let totalTask =
        this.taskView === 'claimed'
          ? this.totalAssignedTasks
          : this.totalGroupTasks
      if (
        !this.areTaskGrouped &&
        this.items.length < totalTask &&
        !this.appendTaskLoader &&
        !(rect.bottom < 0 || rect.top - viewHeight >= viewHeight * 0.2)
      ) {
        func()
      }
    },
    async getSelectedFromRoute() {
      if (this.$router.currentRoute.name === 'task-selected') {
        this.selectedTaskId = this.$route.params.hexId
      } else {
        this.selectedTaskId = null
      }
    },
    async getTasksCountByFormKey() {},
    refreshWithDelay() {
      this.refresh()
      setTimeout(() => this.refresh(), 5000)
    },
    async refreshTasks() {
      let urlParams
      if (this.items.length > 0) {
        urlParams = this.fillUrlParams(1, this.items.length)
      } else {
        urlParams = this.fillUrlParams(1, 10)
      }
      if (this.taskView === 'claimed') {
        await this.$store.dispatch('fetchClaimedTasks', urlParams)
      } else {
        await this.$store.dispatch('fetchUnClaimedTasks', urlParams)
      }
    },
    async refresh() {
      this.taskLoader = true
      try {
        if (this.areTaskGrouped) {
          await this.getTasksItemsGrouped(this.groupByField)
        } else {
          await this.refreshTasks()
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to Group the Tasks',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskLoader = false
      this.taskItems()
      this.$emit('refresh-kpi')
    },
    fillUrlParams: function(page, size) {
      let urlParams
      urlParams = `page=${page}&size=${size}`
      if (this.filterObj !== null && this.filterObj.urlString) {
        urlParams = urlParams + this.filterObj.urlString
      }
      if (this.sortByField) {
        urlParams = urlParams + `&sort=${this.sortByField}`
        let desc = this.sortByLabels.find(
          item => item.value === this.sortByField
        ).desc
        if (desc) urlParams = urlParams + ',desc'
      }
      return urlParams
    },
    async getInitTaskPage() {
      this.taskLoader = true
      let urlParams = this.fillUrlParams(1, 10)
      try {
        if (this.taskView === 'claimed') {
          await this.$store.dispatch('fetchClaimedTasks', urlParams)
          await this.$store.dispatch('fetchTaskGroups')
        } else if (this.taskView === 'unclaimed') {
          await this.$store.dispatch('fetchUnClaimedTasks', urlParams)
          await this.$store.dispatch('fetchTaskGroupsByGroup')
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to Fetch the Tasks',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskLoader = false
      this.$emit('view-mounted')
    },
    async appendTasks() {
      this.appendTaskLoader = true
      let currentPage = 1
      if (this.items.length >= 10) {
        currentPage = Math.ceil(this.items.length / 10) + 1
      }
      let urlParams = this.fillUrlParams(currentPage, 10)
      try {
        if (this.taskView === 'claimed') {
          await this.$store.dispatch('appendClaimedTasks', urlParams)
        } else if (this.taskView === 'unclaimed') {
          await this.$store.dispatch('appendUnclaimedTasks', urlParams)
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to Fetch the Tasks',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.appendTaskLoader = false
    },
    groupTask() {
      this.groupDialog = false
      this.areTaskGrouped = true
      if (this.areTaskGrouped && this.groupByField) {
        this.getTasksItemsGrouped(this.groupByField)
      }
    },
    async getTasksItemsGrouped(field) {
      this.taskGroupingLoader = true
      let labelItem = this.groupByLabels.find(i => i.value === field)
      let urlParams = ''
      if (labelItem.dimension) {
        urlParams = `dimensionName=${labelItem.dimension}&dimensionValue=${labelItem.label}`
      } else {
        urlParams = `dimensionName=${labelItem.value}`
      }
      let groupHeaders
      if (this.taskView === 'claimed') {
        groupHeaders = await this.$store.dispatch(
          'fetchTaskGroupHeaders',
          urlParams
        )
      } else {
        groupHeaders = await this.$store.dispatch(
          'fetchTaskGroupHeadersByGroup',
          urlParams
        )
      }
      let groupTaskHeaders = []
      if (groupHeaders === null || groupHeaders.length === 0) {
        this.groupByItems = []
      }
      groupHeaders.forEach(item => {
        let groupTaskHeader = {}
        groupTaskHeader.label = item.label
        if (item.type != null) {
          groupTaskHeader.taskType = item.type
          groupTaskHeader.taskTypeCaption = this.getTaskTypeCaption(
            groupTaskHeader
          )
        }
        if (item.claimable) {
          groupTaskHeader.claimable = item.claimable
        }

        groupTaskHeader.groupName = labelItem.label
        groupTaskHeader.dimension = labelItem.dimension
        groupTaskHeader.value = labelItem.value
        groupTaskHeader.valueField = labelItem.valueField
        groupTaskHeader.noOfTasks = item.count
        groupTaskHeader.inProgress = item.in_progress
        groupTaskHeader.tasks = []
        groupTaskHeaders.push(groupTaskHeader)
        this.groupByItems = groupTaskHeaders
      })
      this.taskGroupingLoader = false
    },
    getTaskTypeCaption(item) {
      if (item.taskType === 1) {
        return 'User Input Task'
      } else if (item.taskType === 0) {
        return 'Approval Task'
      } else {
        return 'Empty Task'
      }
    },
    searchTasks() {
      if (this.search.length >= 3 && !this.areTaskGrouped) {
        this.taskLoader = true

        this.taskLoader = false
      } else {
        this.fuseFilter = null
      }
      this.taskItems()
    },
    taskItems() {
      this.taskLoader = true
      this.items = this.getItems()
      this.taskLoader = false
      this.filterDialog = false
    },
    getItems() {
      if (this.taskView === 'claimed') {
        return this.claimedTasks
      } else if (this.taskView === 'unclaimed') {
        return this.unclaimedTasks
      } else if (this.taskView === 'support') {
        return this.ownTasks
      }
    },
    gotoTop() {
      this.$vuetify.goTo(0)
    },
    getTotalTasks() {
      return this.taskView === 'claimed'
        ? this.totalAssignedTasks
        : this.totalGroupTasks
    },
    async setGroupByLabels() {
      if (this.taskView === 'claimed') {
        await this.$store.dispatch('fetchTaskGroups')
      } else if (this.taskView === 'unclaimed') {
        await this.$store.dispatch('fetchTaskGroupsByGroup')
      }
    }
  },
  computed: {
    ...mapState({
      claimedTasks: state => state.tasks.claimedTasks,
      taskGroups: state => state.tasks.taskGroups,
      taskGroupHeaders: state => state.tasks.taskGroupHeaders,
      associatedFormKeys: state => state.tasks.associatedFormKeys,
      unclaimedTasks: state => state.tasks.unclaimedTasks,
      totalAssignedTasks: state => state.tasks.totalAssignedTasks,
      totalGroupTasks: state => state.tasks.totalGroupTasks,
      ownTasks: state => state.tasks.ownTasks,
      user: state => state.session.user
    }),
    ...mapGetters({
      can: 'can'
    }),

    taskShownPercent() {
      return Math.round(
        (this.items.length /
          (this.taskView === 'claimed'
            ? this.totalAssignedTasks
            : this.totalGroupTasks)) *
          100
      )
    },
    groupByLabels() {
      let labels = []
      labels = [
        // {
        //   label: 'Task Name',
        //   value: 'name',
        //   formKey: '*',
        //   count: this.getTotalTasks()
        // },
        {
          label: 'Task Key',
          value: 'formKey',
          formKey: '*',
          count: this.getTotalTasks()
        },
        {
          label: 'Created At',
          value: 'createdAt',
          formKey: '*',
          count: this.getTotalTasks()
        },
        {
          label: 'Due At',
          value: 'due',
          formKey: '*',
          count: this.getTotalTasks()
        }
      ]
      if (this.taskGroups && this.taskGroups.length === 4) {
        this.taskGroups[0].dimension1.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension1',
            valueField: 'value1',
            value: 'dimension1' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[1].dimension2.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension2',
            valueField: 'value2',
            value: 'dimension2' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[2].dimension3.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension3',
            valueField: 'value3',
            value: 'dimension3' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[3].dimension4.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension4',
            valueField: 'value4',
            value: 'dimension4' + ':' + item.dimension + ':' + item.formKey
          })
        })
      }
      let _self = this
      if (_self.searchGroupFields) {
        labels = _.filter(labels, function(e) {
          return (e.label
            ? e.label
                .toLowerCase()
                .includes(_self.searchGroupFields.toLowerCase())
            : false) ||
            (e.formKey
              ? e.formKey
                  .toLowerCase()
                  .includes(_self.searchGroupFields.toLowerCase())
              : false) ||
            e.formKeyDesc
            ? e.formKeyDesc
                .toLowerCase()
                .includes(_self.searchGroupFields.toLowerCase())
            : false
        })
      }

      return _.uniqBy(labels, function(e) {
        return e.value
      })
    }
  }
}
</script>

<style scoped></style>
